export function getRaptorCookieId() {
    return `rsa`;
}
